import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { QuestionCardAiMenu } from '../../features/question-card-ai/components/QuestionCardAiMenu';
import { useQuestionCardAiMenuItems } from '../../features/question-card-ai/hooks/useQuestionCardAiMenuItems';
import { useQuizList } from '../useQuizList';
import { useOrderItems } from './Order/useOrderItems';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { EditableOrder } from './Order';
import { useQuizControl } from './QuizControlProvider';

/**
 * 순서 맞추기 카드 본문.
 *
 * `MultipleBody` 와 같은 뼈대지만 **보기 섞기 버튼이 없다** — 배열 순서가 곧
 * 정답이라 저자가 섞으면 정답이 바뀐다. 대신 편집 중에는 `OrderShuffleNotice`
 * 가 "풀 때 자동으로 섞인다"는 것을 알려준다.
 */
export const OrderBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    control,
    id,
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    items: aiMenuItems,
    trackMenuOpen
  } = useQuestionCardAiMenuItems({
    quizId: id,
    quizIndex: index,
    place: 'mobile_drawer'
  });
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    items,
    handleRemove,
    handleMove,
    handleAdd
  } = useOrderItems({
    control,
    index
  });
  return <Fragment>
      <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
        {leftSlot}
        <div className="flex flex-row items-center gap-xs">
          <QuestionCardAiMenu />
          <EditTools.QuizDuplicateButton />
          <EditTools.QuizDeleteButton />
          <EditTools.EditToolsDrawer onOpen={trackMenuOpen} tools={[...aiMenuItems.map(item => ({
          icon: item.icon,
          label: item.label,
          onClick: item.onSelect,
          disabled: item.disabled,
          description: item.reason
        })), {
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.duplicate.button')),
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.delete')),
          onClick: () => {
            void handleDelete(index);
          }
        }]} />
        </div>
      </div>

      <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
        <EditableOrder items={items} handleRemove={handleRemove} handleMove={handleMove} handleAdd={handleAdd} />
        <EditableHint />
      </div>
    </Fragment>;
});